import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import notify from '@ananasbear/notify'

export const downloadBlob = (response, fallbackFilename) => {
  const contentDisposition = response.headers?.get('content-disposition') || ''
  const encodedFilename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  const plainFilename = contentDisposition.match(/filename="?([^";]+)"?/i)?.[1]
  let filename = plainFilename || fallbackFilename

  if (encodedFilename) {
    try {
      filename = decodeURIComponent(encodedFilename)
    } catch (error) {
      filename = encodedFilename
    }
  }

  const url = URL.createObjectURL(response.data)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

export const downloadArchive = async (endpoint, filename) => {
  try {
    const response = await api.get(endpoint, { responseType: 'blob' })
    if (response.code === 403) {
      const { detail } = await response.data.json()
      if (['Document does not have any files.', 'Document does not have any vehicle inspection proofs.'].includes(detail)) {
        notify.warning('notify.archiveFilesEmpty')
        return false
      }
    }
    if (!await requestValidation(response)) {
      notify.error('notify.archiveDownloadError')
      return false
    }

    downloadBlob(response, filename)
    return true
  } catch (error) {
    notify.error('notify.archiveDownloadError')
    return false
  }
}
